import type { ReactNode } from "react";

interface DashboardKpiCardProps {
  label: string;
  value: string;
  hint?: string;
  trend?: string;
  trendUp?: boolean;
  icon: ReactNode;
  accent?: "teal" | "emerald" | "amber" | "violet";
}

const accentMap = {
  teal: "ph-kpi--teal",
  emerald: "ph-kpi--emerald",
  amber: "ph-kpi--amber",
  violet: "ph-kpi--violet",
};

export function DashboardKpiCard({
  label,
  value,
  hint,
  trend,
  trendUp,
  icon,
  accent = "teal",
}: DashboardKpiCardProps) {
  return (
    <div className={`ph-kpi-card ${accentMap[accent]}`}>
      <div className="ph-kpi-icon">{icon}</div>
      <div className="ph-kpi-body">
        <div className="ph-kpi-label">{label}</div>
        <div className="ph-kpi-value">{value}</div>
        {hint && <div className="ph-kpi-hint">{hint}</div>}
        {trend && (
          <div className={`ph-kpi-trend ${trendUp ? "up" : "down"}`}>{trend}</div>
        )}
      </div>
    </div>
  );
}
